interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'Our Services', id: 'services' },
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'About Us', id: 'about' },
    { label: 'Contact Us', id: 'contact-form-section' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => scrollToSection('home')}
          >
            <img
              src="https://static.readdy.ai/image/91846066053649284e91c1730b38112a/93e2cec226b73ee4685c8159598e7006.png"
              alt="Design Assist Logo"
              className={`h-12 w-auto transition-all duration-300 ${scrolled ? '' : 'brightness-0 invert'}`}
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-[#2B2B2B] hover:text-[#C5A572]' : 'text-white hover:text-[#C5A572]'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('contact-form-section')}
            className="hidden md:block bg-[#C5A572] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#B8965F] transition-colors cursor-pointer whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
